import { render, staticRenderFns } from "./AddPviForm.vue?vue&type=template&id=c9364f8a&"
import script from "./AddPviForm.vue?vue&type=script&lang=js&"
export * from "./AddPviForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports